import React from "react";
import {Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {getImageBySizeFromCDN} from "../../common/utils";
import {useSelector} from "react-redux";
import ReactHtmlParser from "react-html-parser";

const HomepageStores = () => {
    const {home_store} = useSelector((state) => state.appReducer.init);
    const {mobile_big} = useSelector((state) => state.appReducer);

    if (home_store.length === 0) return null;

    return (
        <div className="h-s-b">
            <Row>
                <Col>
                    <div className="homepage__stores--img-container">
                        <LazyLoadImage
                            alt="Find a Location"
                            title="Buy, sell and exchange at a Rebag retail store near you"
                            src={getImageBySizeFromCDN(`${mobile_big ? home_store[0].mobile_image : home_store[0].table_image}`, "f=auto,q=90,w=1200")}
                        />
                    </div>
                    <div className="h-s-b-c ">
                        <h2>{ReactHtmlParser(home_store[0].title)}</h2>
                        <p>{ReactHtmlParser(home_store[0].sub_copy)}</p>
                        <a href={ReactHtmlParser(home_store[0].url)}>
                            Learn More <i/>
                        </a>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default HomepageStores;